import React from "react";

import DashboardIcon from "@mui/icons-material/Dashboard";
import GroupsIcon from "@mui/icons-material/Groups";
import RecentActorsIcon from '@mui/icons-material/RecentActors';
import DashboardLayout from "../components/common/DashboardLayout";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import GradeIcon from '@mui/icons-material/Grade';

const mainListItemsArray = [
  {
    id: 1,
    label: "Users",
    link: "/agent/users",
    icon: <GroupsIcon />,
  },
   {
    id: 2,
    label: "Subscription-Visit",
    link: "/agent/user-subscription-history",
    icon: <RecentActorsIcon/>,
  },
   {
    id: 3,
    label: "Customer Info",
    link: "/agent/customer-info",
    icon: <SupportAgentIcon />,
  },
    {
    id:4,
    label: "User Rating",
    link: "/agent/user-rating",
    icon: <GradeIcon/>
  }
 
];

export default function AgentDashboardLayout() {
  return <DashboardLayout mainListItems={mainListItemsArray} />;
}
